type BooksyPayStore = {
  state: {
    business: {
      booksyPaySettings: unknown
    }
  }
  getters: {
    'identity/isOwner': boolean
  }
  dispatch: (action: string) => Promise<unknown>
}

const ensureBooksyPaySettingsLoaded = async (store: BooksyPayStore): Promise<void> => {
  if (!store.state.business.booksyPaySettings) {
    await store.dispatch('business/loadBooksyPaySettings')
  }
}

export const resolveBooksyPayEntryRedirect = async (
  store: BooksyPayStore
): Promise<Record<string, unknown> | null> => {
  await ensureBooksyPaySettingsLoaded(store)

  if (!store.getters['identity/isOwner']) {
    return { name: 'calendar' }
  }

  return null
}
